import { SxProps } from "@mui/material";
import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import Button, { ButtonProps } from "./Button";

export type NavButtonProps = {
  route: string;
  isActive?: boolean;
  activeStyle?: SxProps;
  external?: boolean;
  children?: ReactNode;
} & ButtonProps;

const NavButton: FC<NavButtonProps> = ({
  route,
  activeStyle,
  isActive,
  external = false,
  sx,
  children,
  ...props
}) => {
  const combinedSx: SxProps = [
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ...(isActive && activeStyle ? (Array.isArray(activeStyle) ? activeStyle : [activeStyle]) : [])
  ];

  return external ? (
    <Button
      component="a"
      href={route}
      target="_blank"
      rel="noreferrer"
      aria-current={isActive ? "page" : undefined}
      sx={combinedSx}
      {...props}>
      {children}
    </Button>
  ) : (
    <Button
      component={Link}
      to={route}
      aria-current={isActive ? "page" : undefined}
      sx={combinedSx}
      {...props}>
      {children}
    </Button>
  );
};

export default NavButton;
